import React from 'react';
import Icon from 'components/AppIcon';

const KPI_CONFIG = [
  { key: 'totalRevenue', label: 'Ingresos Totales', icon: 'Euro', format: 'currency', color: '#059669', bg: 'rgba(5,150,105,0.1)' },
  { key: 'totalMargin', label: 'Margen Realizado', icon: 'TrendingUp', format: 'currency', color: '#2563eb', bg: 'rgba(37,99,235,0.1)' },
  { key: 'avgMarginPerTon', label: 'Margen Medio €/t', icon: 'BarChart2', format: 'eur_per_ton', color: '#7c3aed', bg: 'rgba(124,58,237,0.1)' },
  { key: 'avgYieldAccuracy', label: 'Precisión Yield', icon: 'Target', format: 'pct', color: '#d97706', bg: 'rgba(217,119,6,0.1)' },
  { key: 'totalTonsSold', label: 'Toneladas Vendidas', icon: 'Package', format: 'tons', color: '#0891b2', bg: 'rgba(8,145,178,0.1)' },
  { key: 'avgDaysToSell', label: 'Días Medios Venta', icon: 'Clock', format: 'days', color: '#be185d', bg: 'rgba(190,24,93,0.1)' },
];

function formatValue(value, format) {
  if (value === null || value === undefined || isNaN(value)) return '—';
  switch (format) {
    case 'currency': return `${Number(value)?.toLocaleString('es-ES', { maximumFractionDigits: 0 })} €`;
    case 'eur_per_ton': return `${Number(value)?.toLocaleString('es-ES', { maximumFractionDigits: 0 })} €/t`;
    case 'pct': return `${Number(value)?.toFixed(1)}%`;
    case 'tons': return `${Number(value)?.toLocaleString('es-ES', { maximumFractionDigits: 1 })} t`;
    case 'days': return `${Number(value)?.toFixed(1)} d`;
    default: return String(value);
  }
}

export default function SalesKPICards({ kpis, loading }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
      {KPI_CONFIG?.map((cfg) => (
        <div
          key={cfg?.key}
          className="bg-card border border-border rounded-xl p-4 flex flex-col gap-3"
          style={{ boxShadow: 'var(--shadow-sm)' }}
        >
          <div className="flex items-center justify-between">
            <div
              className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ background: cfg?.bg }}
            >
              <Icon name={cfg?.icon} size={15} color={cfg?.color} strokeWidth={2} />
            </div>
          </div>
          <div>
            {loading ? (
              <div className="h-6 w-20 bg-muted rounded animate-pulse mb-1" />
            ) : (
              <p
                className="text-xl font-bold text-foreground leading-tight"
                style={{ fontFamily: '"IBM Plex Mono", monospace', fontWeight: 700 }}
              >
                {formatValue(kpis?.[cfg?.key], cfg?.format)}
              </p>
            )}
            <p
              className="text-xs text-muted-foreground mt-0.5"
              style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}
            >
              {cfg?.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
